import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FirstSOVFullImage = "/images/imagePlaceholder.webp";

function Single_property({ property, hideKnowMore }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link to={`/property/${property.serialNumber}`} className="m-0 p-0 group">
      <div 
        className='bg-white flex flex-col justify-between shadow-[rgba(0,0,0,0.08)_0px_4px_20px_0px] hover:shadow-[rgba(0,0,0,0.25)_0px_20px_20px_0px] transition-all duration-500 ease-out w-full min-h-[360px] xs:min-h-[400px] sm:min-h-[440px] md:min-h-[460px] lg:min-h-[46rem] px-[0.8rem] xs:px-[1rem] sm:px-[0rem] rounded-xl overflow-hidden transform hover:scale-[1.03] hover:-translate-y-2 cursor-pointer relative'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        
        {/* Subtle background gradient overlay on hover */}
        <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-[#10c9c0]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
        
        <div className='sm:mx-6 r_xs:mx-0 py-[1.5rem] xs:py-[2rem] sm:py-[2.5rem] md:py-[3rem] relative z-10'>
          {/* Enhanced Image Container with Multiple Effects */}
          <div className="relative overflow-hidden rounded-xl group-hover:rounded-2xl transition-all duration-500 shadow-lg group-hover:shadow-2xl">
            {/* Image */}
            <div className="relative overflow-hidden">
              <img
                className={`w-full h-[260px] xs:h-[280px] sm:h-[300px] md:h-[320px] lg:h-[20rem] object-cover transition-all duration-700 ease-out ${
                  isHovered 
                    ? 'scale-110 brightness-110 contrast-105' 
                    : 'scale-100 brightness-100 contrast-100'
                }`}
                loading='lazy'
                alt={`Akiya 2.0 - ${property.propertyName}`}
                src={imageLoaded ? property.images[0] : FirstSOVFullImage}
                onLoad={() => setImageLoaded(true)}
              />
              
              {/* Loading overlay */}
              {!imageLoaded && (
                <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:200%_100%] animate-[shimmer_1.5s_ease-in-out_infinite] rounded-xl">
                  <div className="absolute inset-0 bg-gray-200/50"></div>
                </div>
              )}
              
              {/* Hover overlay with gradient */}
              <div className={`absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent transition-all duration-500 ${
                isHovered ? 'opacity-100' : 'opacity-0'
              }`}></div>
              

            </div>
            
            {/* Corner accent decoration */}
            <div className={`absolute bottom-0 left-0 w-0 h-0 border-l-[30px] border-l-[#10c9c0] border-t-[30px] border-t-transparent transition-all duration-500 ${
              isHovered ? 'opacity-80 scale-110' : 'opacity-60 scale-100'
            }`}></div>
          </div>

          {/* Enhanced Typography with Staggered Animation */}
          <div className="mt-4 xs:mt-5 sm:mt-6 md:mt-8 space-y-3">
            <h1 className={`text-[#10c9c0] font-bold text-[16px] xs:text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] xl:text-[26px] leading-tight line-clamp-2 transition-all duration-500 ${
              isHovered 
                ? 'text-[#0eb1a9] transform translate-x-1' 
                : 'text-[#10c9c0] transform translate-x-0'
            }`}>
              {property.propertyName}
            </h1>
            
            <p className={`text-[#949995] text-[12px] xs:text-[13px] sm:text-[14px] md:text-[15px] lg:text-[16px] leading-relaxed line-clamp-3 sm:line-clamp-4 md:line-clamp-none transition-all duration-500 delay-75 ${
              isHovered 
                ? 'text-[#737873] transform translate-x-1' 
                : 'text-[#949995] transform translate-x-0'
            }`}>
              {property.smallAbout}
            </p>
          </div>
        </div>

        {/* Clean Button with Subtle Hover Effect */}
        {!hideKnowMore && (
          <div className="relative z-10">
            <button className={`w-full rounded-t-xl flex justify-center items-center py-[0.8rem] xs:py-[1rem] sm:py-[1.2rem] md:py-[1.3rem] bg-[#10c9c0] hover:bg-[#0eb1a9] text-white font-[800] text-[12px] xs:text-[13px] sm:text-[14px] transition-colors duration-300 ease-out`}>
              Know More
            </button>
          </div>
        )}
        
        {/* Subtle border accent */}
        <div className={`absolute inset-0 rounded-xl border-2 transition-all duration-500 pointer-events-none ${
          isHovered 
            ? 'border-[#10c9c0]/30 shadow-[inset_0_0_0_1px_rgba(16,201,192,0.2)]' 
            : 'border-transparent'
        }`}></div>
      </div>
      
      {/* Custom CSS for shimmer animation */}
      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </Link>
  );
}

export default Single_property;